var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6776 3.04031C23.8054 3.093 23.9071 3.19474 23.9598 3.32256C23.9864 3.38622 24 3.45404 24 3.52187V21.2609C24 21.3287 23.9864 21.3966 23.9598 21.4602C23.9071 21.588 23.8054 21.6898 23.6776 21.7425C23.6139 21.7685 23.5461 21.7826 23.4783 21.7826H0.521858C0.454033 21.7826 0.386207 21.7685 0.322555 21.7425C0.19473 21.6898 0.0929911 21.588 0.0402958 21.4602C0.0142089 21.3966 0.00012207 21.3287 0.00012207 21.2609V3.52187C0.00012207 3.45404 0.0142089 3.38622 0.0402958 3.32256C0.0929911 3.19474 0.19473 3.093 0.322555 3.04031C0.386207 3.01422 0.454033 3.00013 0.521858 3.00013H6.56669L6.56683 3H8.0423L8.04216 3.00013H15.9579L15.9578 3H17.4333L17.4334 3.00013H23.4783C23.5461 3.00013 23.6139 3.01422 23.6776 3.04031ZM22.2188 4.0436H17.2174H6.78269H1.78133L3.86827 6.13055H20.1318L22.2188 4.0436ZM19.8261 17.6087V7.17402H4.17401V17.6087H19.8261ZM3.13054 6.86828L1.04359 4.78134V20.0014L3.13054 17.9145V6.86828ZM3.86827 18.6522L1.78133 20.7392H22.2188L20.1318 18.6522H3.86827ZM20.8696 17.9145L22.9565 20.0014V4.78134L20.8696 6.86828V17.9145Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameIcon);
export default __webpack_public_path__ + "static/media/frame_icon.d80a563cb5ba0e0c557b668047814059.svg";
export { ForwardRef as ReactComponent };